import join from 'join-classnames';
import { isObject } from '../../utils/utils';
import styles from './menu.css';
import Icon from '../icon/icon.js';

// Global Menu is of format [{name, url,}]

export const globalMenuTemplate = (globalMenu = [], id, isEclientLink) => {
  const newGlobalMenu = globalMenu.map((globalMenuItem, index) => ({
    ...globalMenuItem,
    id: globalMenuItem.id || `id_${index}`
  }));
  let isDisplayButtonIcon = true;
  if (newGlobalMenu && newGlobalMenu.length <= 1) {
    isDisplayButtonIcon = false;
  }
  const ariaControlIds = newGlobalMenu
    .filter(
      (newGlobalMenuItem) =>
        newGlobalMenuItem.isActive === undefined ||
        newGlobalMenuItem.isActive === false,
    )
    .map((newGlobalMenuItem) => newGlobalMenuItem.id)
    .join(',');
  return `
  <div class="${styles.globalMenuWrapper} ${isEclientLink ? styles.handleForEclient : ''}">
    ${
  ariaControlIds === ''
    ? ''
    : `<button type="button" aria-controls="${ariaControlIds}" class="${join(styles.iconButton, !isDisplayButtonIcon && styles.hide)}">
    <span class="${styles.spanIcon}">
      ${Icon('arrowSmallRight')}
    </span>
  </button>`
}
    <ol id="${id}" class="${styles.unStyledList} ${styles.globalMenu}"role="heading" aria-level="2">
    ${newGlobalMenu.reduce(
    (acc, { name = '', isActive = false }) => `${acc}
      <li class="${styles.globalMenuItem}">
        ${
  isActive
    ? `<button type="button" aria-controls="${ariaControlIds}" >
        ${name}
      </button>`
    : `<h2 class="${styles.headingAdminHome}">${name}</h2>`
}
      </li>`,
    '',
  )}
    </ol>
  </div>`;
};

// Context Menu can be an array or an object
// Object format is {name, children} => this would be a button with a dropdown
// Array format is [{name, url, children}] => this would be a menu format

export const contextMenuTemplate = (contextMenu = [], id, isEclientLink) => {
  if (isObject(contextMenu)) {
    const {
      name: contextMenuName = '',
      children: contextMenuChildren = [],
      isCurrent,
      onClickId: onClickIdButton,
      isExpanded: isItemExpanded = false,
      id: itemId = ''
    } = contextMenu;
    return `
      <button 
        type="button" 
        aria-controls="${id}" 
        class="${join(
    styles.contextMenuItemButton,
    isItemExpanded && `${styles.rotate}`,
    isCurrent &&
            `${styles.contextMenuCurrentItem} oct-common-header-primary-color`,
  )}"
        ${onClickIdButton ? `data-on-click-id="${onClickIdButton}"` : ''}
      >
        <span class="${styles.contextMenuButtonText}">
          ${contextMenuName}
        </span>
         <span class="${styles.spanIcon} ${itemId}">
          ${Icon('arrowSmallRight')}
        </span>
      </button>
      <ol id="${id}"
      class="${styles.unStyledList} 
      ${isItemExpanded ? '' : styles.initialCollapseChilds} ${styles.contextMenu}" 
      aria-expanded="${isItemExpanded}" role="menu" aria-hidden="${!isItemExpanded}"
      >
      ${contextMenuChildren.reduce(
    (
      acc,
      {
        name = '',
        url = '',
        onClickId,
        isCurrent: isCurrentChild,
        children = [],
        isExpanded = false,
        id: childId = ''
      },
      index,
    ) => `${acc}
  <li
  class="${join(
    styles.contextMenuIconItem,
    `${childId}`,
    isCurrentChild &&
      `${styles.contextMenuCurrentItem} oct-common-header-primary-color oct-primary-background-color-trasparent`,
  )}"
>
    ${
  children.length === 0
    ? `<a
        class="${join(styles.contextMenuLink)}"
        href="${url}"
        ${onClickId ? `data-on-click-id="${onClickId}"` : ''}
        tabindex="-1"
      >${name}</a>`
    : contextMenuTemplate({ name, children, isExpanded }, `${id}_${index}`)
}
        </li>`,
    '',
  )}
      </ol>
    `;
  }
  return `<ol id="${id}" class="${styles.unStyledList} ${styles.contextMenu}" role="menu" aria-expanded="true">
    ${contextMenu.reduce(
    (
      acc,
      {
        name = '',
        url = '',
        isCurrent,
        onClickId,
        children = [],
        id: itemId = '',
        target = '',
        isDisplayMax = false,
        isDisplayMiniScreen = false,
        isExpanded = false
      },
      index,
    ) => `${acc}
      <li
        class="${join(
    isCurrent &&
            `${styles.contextMenuCurrentItem} 
          oct-common-header-primary-color oct-primary-background-color-trasparent`,
  )} 
          ${isDisplayMax ? styles.displayInDesktop : styles.displayInMedium} 
          ${isEclientLink ? styles.handleForEclientListItem : ''}
          ${isDisplayMiniScreen ? styles.displayInMiniScreen : ''} 
          ${isEclientLink ? styles.handleForEclient : ''}"
      >
        ${
  children.length === 0
    ? `<span
      class="${join(styles.contextMenuButtonWrapper, isCurrent && 'oct-primary-background-color-trasparent')}"
      ${onClickId ? `data-on-click-id="${onClickId}"` : ''}
    >
      <a class="${styles.contextMenuItemText}" href="${url}" tabindex="0" target="${target}" >${name}</a>
    </span>`
    : contextMenuTemplate(
      {
        name,
        children,
        isExpanded,
        id: itemId
      },
      `${id}_${index}`,
    )
}
    </li>`,
    '',
  )}
    </ol>`;
};

export const greetingTemplateId = 'greetingTemplateId';

export const greetingTemplate = (greetingObj) => {
  const {
    image = '',
    name = '',
    logoutTitle = '',
    logoutLink = '',
    nameInitials = ''
  } = greetingObj;
  return `<div tabindex="0" id="${greetingTemplateId}" class="${styles.greetingInfo} ${logoutLink.length === 0 ? styles.handleForEclient : ''} ">
    <span  role="img" tabindex="0" arialabel="${nameInitials}" class="${image ? styles.greetingImageWrapper : styles.hideGreetingImage} fs-exclude">
      <img src="${image}" alt=${nameInitials} />
    </span>
    <span tabindex="0" arialabel="${nameInitials}" class="${!image ? styles.greetingImageText : styles.hideGreetingImage} fs-exclude">
      <span tabindex="0" class="${styles.nameInitials}">
      ${nameInitials}
      </span>
    </span>
    <span role="button" tabindex="0" title="${name}" class="${styles.greetingInfoTextWrapper}">
      <div tabindex="0" class="${styles.userName} fs-mask">${name}</div>
      <div role="button" arialabel="${logoutTitle}" tabindex="0" class="${styles.logout}" id="logoutButton"}>
        <span tabindex="0" title="${logoutTitle}">${logoutTitle}</span>
        </a>
      </div>
    </span>
  </div>`;
};

const globalMenuPlaceholderId = 'globalMenuPlaceholder';
export const globalMenuPlaceholderSelector = '#globalMenuPlaceholder';

const contextMenuPlaceholderId = 'contextMenuPlaceholder';
export const contextMenuPlaceholderSelector = '#contextMenuPlaceholder';

const greetingPlaceholderId = 'greetingPlaceholder';
export const greetingPlaceholderSelector = '#greetingPlaceholder';

export const placeholderTemplate = () => `
  <div id="${globalMenuPlaceholderId}"></div>
  <div id="${contextMenuPlaceholderId}"></div>
  <div id="${greetingPlaceholderId}"></div>`;
